import req from '../../api/request'
import type { SnEvent } from '../../features/event/types'

/**
 * Events for one team in one season — the slice a team calendar shows.
 * Upcoming only, soonest first.
 *
 * Takes no query params: the endpoint accepts none, so date/venue/division
 * narrowing has to happen client-side. Not paginated either, so the whole
 * season arrives in one response.
 */
export const listRosterEvents = async (
  teamId: string,
  rosterId: string
): Promise<SnEvent[]> => {
  const response = await req(`/teams/${teamId}/rosters/${rosterId}/events`)
  // The guide documents a `{ data: … }` envelope, but sibling list endpoints
  // (notably `/teams/{team}/rosters`) return a bare array — so accept either
  // rather than silently yielding nothing.
  const events = Array.isArray(response) ? response : response?.data
  return (events ?? []) as SnEvent[]
}
